import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { BookingLocationCodes } from '@fcom/common/interfaces/booking';
import { GlobalBookingTripDates } from '@fcom/common/interfaces';
import { TripType } from '@fcom/core/constants';

import { StatusBarComponentProps, StatusBarMode } from './status-bar.interfaces';

@Component({
  selector: 'fin-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBarComponent implements StatusBarComponentProps {
  public readonly TripType = TripType;

  readonly stylesMap = {
    [StatusBarMode.HEADER]: {
      textColor: 'white-text',
      backgroundColor: 'nordic-blue-900-bg',
      display: 'flex flex--middle flex--wrap',
      textSize: 'medium-type',
      spacing: 'status-bar-wrapper pr-small-y',
    },
    [StatusBarMode.INLINE]: {
      textColor: 'white-text',
      backgroundColor: '',
      display: 'flex flex--middle flex--wrap',
      textSize: 'medium-type',
      spacing: 'status-bar-wrapper pr-small-y',
    },
    [StatusBarMode.BLOCK]: {
      textColor: 'nordic-blue-900-text',
      backgroundColor: '',
      display: 'block',
      textSize: '',
      spacing: '',
    },
  };

  @Input() tripType: TripType;
  @Input() locations: BookingLocationCodes[] = [];
  @Input() paxAmount: number;
  @Input() dates: GlobalBookingTripDates = { departureDate: null, returnDate: null };
  @Input() mode: StatusBarMode = StatusBarMode.HEADER;
  @Input() displayAirportName = false;
}
